import { getLocationSearchToObject } from '../../utils/format';

export default function() {
  const params = getLocationSearchToObject();
  let enablePopup = true;
  if (params && params.email) {
    enablePopup = false;
  }

  if (enablePopup) {
    const modalNamespace = 'popup-modal';
    const modal = window.modalManager.idModalMap.get(modalNamespace);

    if (modal) {
      const { namespace } = modal.element.dataset;
      const cookieName = `popup-${namespace}`;
      const cookieIsSet = window.localStorage.getItem(cookieName);

      if (!cookieIsSet) {
        modal.show();
        modal.on('hide', () => {
          window.localStorage.setItem(cookieName, true);
        });
      }
    }
  }
}
